<template>
    <OldGuiFrame v-if="showOldImportGui" />
    <v-container v-else-if="userAllowedImportExport" fluid class="pa-0" style="background-color: white;">
        <v-row no-gutters>

            <v-col cols="5" class="pa-4">
                <h2 class="mb-3">Import data</h2>

                <ImportVisualizer :importInProgress="importInProgress" :progressText="importProgressText"
                    :importError="importError" :importSuccess="importSuccess"
                    :importSteps="importSteps"
                    @reset="importInProgress = false; importError = null; importSuccess = null;">
                </ImportVisualizer>

                <div class="mx-0 mt-3">
                    <v-skeleton-loader v-if="isLoading" type="list-item-two-line" height="80" class="mb-2">
                    </v-skeleton-loader>
                    <template v-else>
                        <QTextField v-model="successEmail" label="Send email on import success to" disabled>
                        </QTextField>
                        <QTextField v-model="errorEmail" label="Send email on import error to" disabled>
                        </QTextField>
                    </template>
                </div>
            </v-col>

            <v-divider vertical style="z-index: 1;"></v-divider>

            <v-col cols="7">
                <ImportSamples class="mb-3 pa-3" />
                <ImportHistory ref="History" />
            </v-col>

        </v-row>
    </v-container>

    <NoImportExportPermission v-else>
    </NoImportExportPermission>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ImportVisualizer from './ImportVisualizer.vue';
import ImportHistory from './ImportHistory.vue';
import ImportSamples from './ImportSamples.vue';
import OldGuiFrame from "@/views/landingpages/OldGuiFrame.vue";
import NoImportExportPermission from '../landingpages/NoImportExportPermission.vue';

export default {
    name: 'Import',
    props: {},
    components: {
        ImportVisualizer,
        ImportHistory,
        ImportSamples,
        OldGuiFrame,
        NoImportExportPermission,
    },
    mixins: [ClientAPIMixin],

    data() {
        return {
            importInProgress: false,
            importProgressText: null,
            importError: null,
            importSuccess: null,

            errorEmail: '',
            successEmail: '',
            importSteps: [],

            subscriptions: [
                { eventKey: SRConst.EventKeys.ImportProgressEvent, handler: this.handleImportProgress },
                { eventKey: SRConst.EventKeys.ImportFailedEvent, handler: this.handleImportFailed },
                { eventKey: SRConst.EventKeys.ImportSuccessEvent, handler: this.handleImportSuccess }
            ],

            isLoading: false,
        };
    },

    mounted() {
        this.subscribe();
        this.fetch();
    },

    beforeDestroy() {
        this.unsubscribe();
    },

    methods: {
        subscribe() {
            this.subscriptions.forEach(e => {
                this.$store.dispatch("NotificationStore/subscribe", [e.eventKey, e.handler]);
            });
        },

        unsubscribe() {
            this.subscriptions.forEach(e => {
                this.$store.dispatch("NotificationStore/unsubscribe", [e.eventKey, e.handler]);
            });
        },

        handleImportProgress(args) {
            this.importError = null;
            this.importSuccess = null;
            this.importInProgress = true;
            //console.log("Import progress", args);
            this.importProgressText = args.message;
        },
        handleImportSuccess(args) {
            this.importSuccess = args;
            this.importInProgress = false;
            //console.log("Import success", args);
            this.refreshHistory();
        },
        handleImportFailed(args) {
            this.importError = args;
            this.importInProgress = false;
            console.log("Import failed", args);
            this.refreshHistory();
        },

        refreshHistory() {
            this.$refs.History.fetch();
        },


        async fetch() {
            this.isLoading = true;
            try {
                var status = await this.getImportStatus();
                //console.log('status', status)
                this.importInProgress = status.InProgress;
                this.importProgressText = status.ProgressText;
                this.errorEmail = status.ErrorEmail ?? '';
                this.successEmail = status.SuccessEmail ?? '';
                this.importSteps = status.ImportSteps ?? status.importSteps ?? [];
            } finally {
                this.isLoading = false;
            }
        },
    },

    computed: {
        showOldImportGui() {
            return this.$store.state.GlobalSettings?.ShowOldImportGui === true;
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>